export const b2bFormField = [
	{
		type: 'hidden',
		formControlName: 'id',
	},

	{
		type: 'text',
		title: 'Shortcode',
		placeholder: 'Enter Shortcode',
		formControlName: 'shortcode',
		required: true,
		maxLength: 100,
		errorsMsg: [
			{ type: 'required', message: 'Shortcode is required' },
			{
				type: 'maxlength',
				message: 'Shortcode should be less than 100 characters',
			},
		],
	},
	{
		type: 'text',
		title: 'Name',
		placeholder: 'Enter Name',
		formControlName: 'name',
		required: true,
		maxLength: 100,
		errorsMsg: [
			{ type: 'required', message: 'Name is required' },
			{
				type: 'maxlength',
				message: 'Name should be less than 100 characters',
			},
		],
	},
	{
		type: 'url',
		title: 'companyLogo(*jpg/jpeg/png)',
		placeholder: 'Enter URL',
		formControlName: 'logo',
		required: true,
		errorsMsg: [
			{ type: 'required', message: 'URL is required' },
			{ type: 'pattern', message: 'Enter a valid URL' },
		],
	},
	{
		type: 'toggle',
		title: 'Onboarding Skip',
		placeholder: 'Onboarding Skip',
		formControlName: 'onBoardingSkip',
		size: 6,
	},
	{
		type: 'toggle',
		title: 'Term & Condition',
		placeholder: 'Term & Condition',
		formControlName: 'termCondition',
		size: 6,
	},
];
